<template>
    <div class="row">
        <div class="col-4">
            <CredentialTypeSelect class="mb-3" />
            <SlideYUpTransition :delay="200" :duration="400">
                <div v-if="credentialType && credentialType.multiple === false" class="alert alert-info">
                    {{$t('credentials.one_account_only_alert', {type: credentialType.name})}}
                </div>
            </SlideYUpTransition>

            <div class="card">
                <SlideYUpTransition :delay="200" :duration="400">
                    <CredentialSelect v-if="credentialType" />
                </SlideYUpTransition>
                <div v-if="!credentialType" class="card-body text-muted">
                  {{$t('credentials.select_type_alert')}}
                </div>
            </div>
        </div>

        <div class="col-8">
            <SlideXLeftTransition :delay="100">
                <div v-if="showForm" class="card">
                    <div class="card-body">
                        <Form />
                    </div>
                </div>
            </SlideXLeftTransition>
        </div>
    </div>
</template>

<script>

    import {SlideYUpTransition} from 'vue2-transitions';
    import {SlideXLeftTransition} from 'vue2-transitions';
    import CredentialTypeSelect from "../components/CredentialTypeSelect";
    import CredentialSelect from "../components/CredentialSelect";
    import Form from "../components/Form";
    import store from "../store/store";
    import {FETCH_CREDENTIALS, RESET_STATE} from "../store/types";

    export default {
        name: "Credentials",
        components: {SlideYUpTransition, SlideXLeftTransition, CredentialSelect, CredentialTypeSelect, Form},
        computed: {
            ...store.mapGetters('Auth', ['user']),
            ...store.mapGetters(['credentialType']),
            ...store.mapState(['showForm']),
        },

        beforeRouteEnter: async (to, from, next) => {
            await store.dispatch(RESET_STATE);
            store.dispatch(FETCH_CREDENTIALS);

            return next();
        }
    }
</script>
